__turbopack_context__.v({
  "app_light_theme": "style-module-scss-module__ZEgEUq__app_light_theme",
  "rights": "style-module-scss-module__ZEgEUq__rights",
});
